module.exports = __webpack_public_path__ + "img/bonus_symbol_4.2c248ff8.png";